// import React, { useEffect, useState } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import Products from './Products';
// import {
//   Box,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Grid,
//   IconButton,
//   InputLabel,
//   MenuItem,
//   Pagination,
//   Select,
// } from '@mui/material';
// import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
// import * as XLSX from 'xlsx';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import DashboardCard2 from 'src/components/shared/DashboardCard2';
// // import Book1Product from '../../assets/excel/Book1Product.xlsx';
// import Book2Product from '../../assets/excel/Book2Product.xlsx';
// import SearchImg from '../../assets/search.svg';

// import { MdClear } from "react-icons/md";
// import { useSelector, useDispatch } from 'react-redux';
// import {
//   setAllProductData,
//   setSearchFilter,
//   setItemsPerPage,
//   setCurrentPage,
//   removeProductsFromState,
//   resetFilters,
// } from 'src/redux/slices/productSlice';

// const AllProducts = () => {
//   const dispatch = useDispatch();

//   const [checkedProducts, setCheckedProducts] = useState([]);
//   const [deleteLoading, setDeleteLoading] = useState(false);
//   const [openDialogue, setOpenDialogue] = useState(false);
//   const [uploadedData, setUploadedData] = useState(null);
//   const [showLoader, setShowLoader] = useState(true);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const {
//     filteredProducts,
//     pagination,
//     filters
//   } = useSelector((state) => ({
//     filteredProducts: state.product.filteredProducts,
//     pagination: state.product.pagination,
//     filters: state.product.filters
//   }));

//   const { fetchAllProducts, activeBranchId, createManyProduct, setShowMessage, deleteManyProduct } = useMain();

//   useEffect(() => {
//     if (activeBranchId) {
//       getData();
//       dispatch(resetFilters());
//     }
//   }, [activeBranchId]);


//   const getData = async () => {
//     try {
//       setShowLoader(true);
//       const res = await fetchAllProducts(activeBranchId);
//       if (res.statusCode === 200) {
//         dispatch(setAllProductData(res?.data));
//       } else {
//         setShowMessage({
//           message: res.message || 'Failed to fetch data',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Something went wrong',
//         messageType: 'error',
//       });
//     } finally {
//       setShowLoader(false);
//     }
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
//         const sheet = workbook.Sheets[workbook.SheetNames[0]];
//         const json = XLSX.utils.sheet_to_json(sheet);
//         setUploadedData(json);
//       };
//       reader.readAsArrayBuffer(file);
//     }
//   };

//   const downloadExcelTemplate = () => {
//     const a = document.createElement('a');
//     a.href = Book2Product;
//     a.download = 'product_template.xlsx';
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     closeModal();
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     if (!uploadedData) {
//       return setShowMessage({ message: 'Upload a valid file', messageType: 'error' });
//     }

//     try {
//       setShowLoader(true);
//       const res = await createManyProduct(activeBranchId, { bulkData: uploadedData });
//       if (res?.statusCode === 200) {
//         setShowMessage({ message: res.message || 'Uploaded successfully', messageType: 'success' });
//         setUploadedData(null);
//         getData();
//       } else {
//         setShowMessage({ message: res.message || 'Upload failed', messageType: 'error' });
//       }
//     } catch (err) {
//       setShowMessage({ message: err.message || 'Something went wrong', messageType: 'error' });
//     } finally {
//       setShowLoader(false);
//       closeModal();
//     }
//   };



//   const handleLimitChange = (e) => {
//     const newLimit = Number(e.target.value);
//     dispatch(setItemsPerPage(newLimit));
//     // No need to manually set currentPage here - it's handled in the reducer
//   };

//   const handlePageChange = (e, page) => {
//     dispatch(setCurrentPage(page));
//   };

//   const handleSearchChange = (e) => {
//     dispatch(setSearchFilter(e.target.value));
//   };

//   const handleBulkDelete = () => {
//     setOpenDialogue(true);
//   };

//   const handleCloseDialogue = () => {
//     setOpenDialogue(false);
//   };

//   const submitBulkDelete = async () => {
//     try {
//       setDeleteLoading(true);
//       const productIds = checkedProducts.map((item) => item?._id);
//       const res = await deleteManyProduct({ ids: productIds }, activeBranchId);
//       if (res.statusCode === 200) {
//         setShowMessage({ message: 'Products deleted successfully', messageType: 'success' });
//         setCheckedProducts([]);
//         dispatch(removeProductsFromState(productIds));
//       } else {
//         setShowMessage({ message: res.message || 'Error deleting products', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//     } finally {
//       setDeleteLoading(false);
//       handleCloseDialogue();
//     }
//   };

//   const openModal = () => {
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//   };

//   return (
//     <PageContainer title="Manage Products" description="this contains all Products">
//       <DashboardCard2 title="Manage Products">
//         <div style={{ display: 'grid', gridTemplateColumns: '2fr auto' }}>
//           <div style={{ marginBottom: '1.7rem' }}>
//             <InputLabel>Show per page</InputLabel>
//             <Select
//               style={{
//                 borderRadius: '7px',
//                 border: '0.5px solid #6174DD',
//                 padding: '4px 12px',
//                 background: '#FFF',
//                 height: '40px',
//                 width: '10%',
//               }}
//               value={pagination.itemsPerPage}
//               onChange={handleLimitChange}
//             >
//               <MenuItem value={10}>10</MenuItem>
//               <MenuItem value={50}>50</MenuItem>
//               <MenuItem value={100}>100</MenuItem>
//               <MenuItem value={200}>200</MenuItem>
//             </Select>
//           </div>

//           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', alignItems: 'center', gap: '1.2rem', width: '76%' }}>
//             <div style={{ marginBottom: '1.6rem', marginRight: '-4.8rem' }} onClick={() => document.getElementById('search-input').focus()}>
//               <InputLabel>Search</InputLabel>
//               <div className="search-input" style={{ display: 'flex', alignItems: 'center' }}>
//                 <img src={SearchImg} alt="" />
//                 <input
//                   id="search-input"
//                   type="text"
//                   placeholder=""
//                   value={filters.search || ''}
//                   onChange={handleSearchChange}
//                   style={{ marginLeft: '0.5rem' }}
//                 />
//                 {filters.search && (
//                   <IconButton
//                     onClick={() => dispatch(setSearchFilter(''))}
//                     style={{ padding: 1 }}
//                   >
//                     <MdClear style={{
//                       // color: '#ff4d4d',
//                       color: '#000',
//                       // color: '#A2A3AE',
//                       marginRight: '-0.2rem', marginTop: '0.1rem',
//                       fontSize: '1.1rem'
//                     }} />
//                   </IconButton>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         <Grid container justifyContent="flex-end">
//           <Grid item justifyContent="flex-end">
//             {checkedProducts.length ? (
//               <Button
//                 variant="contained"
//                 color="primary"
//                 target="_blank"
//                 sx={{
//                   background: '#ff4d4d',
//                   '&:hover': {
//                     background: '#ff6666',
//                   },
//                 }}
//                 onClick={handleBulkDelete}
//               >
//                 Delete
//               </Button>
//             ) : (
//               <Button
//                 variant="contained"
//                 color="primary"
//                 target="_blank"
//                 sx={{
//                   background: '#6174DD',
//                 }}
//                 onClick={openModal}
//               >
//                 Product Upload
//               </Button>
//             )}
//           </Grid>
//         </Grid>


//         {/* Modal Dialog */}
//         <Dialog open={isModalOpen} onClose={closeModal}>
//           <DialogTitle>Create Many Products</DialogTitle>
//           <form onSubmit={handleFormSubmit}>
//             <Box p={2}>
//               <input
//                 type="file"
//                 accept=".xlsx, .xls"
//                 onChange={handleFileChange}
//               />
//             </Box>
//             {showLoader && <ShowLoader value={showLoader} />}
//             <Box p={2}>
//               <Button type="submit" variant="contained" color="primary">
//                 Submit
//               </Button>
//               <Button
//                 variant="outlined"
//                 color="primary"
//                 sx={{ ml: 2 }}
//                 onClick={downloadExcelTemplate}
//               >
//                 <ArrowCircleDownIcon sx={{ margin: '0px 2px 0px 0px' }} />
//                 Sample Download
//               </Button>
//             </Box>
//           </form>
//         </Dialog>

//         {/* Delete Dialog */}
//         <Dialog open={openDialogue} onClose={handleCloseDialogue}>
//           <DialogTitle>Delete item</DialogTitle>
//           <DialogContent>
//             <DialogContentText>Are you sure you want to delete this data?</DialogContentText>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseDialogue}>Cancel</Button>
//             <Button onClick={submitBulkDelete} autoFocus>
//               Delete
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {showLoader ? (
//           <ShowLoader />
//         ) : filteredProducts.length > 0 ? (
//           <Box>
//             <Grid container spacing={3}>
//               <Grid item xs={12} lg={12}>
//                 <Products
//                   checkedProducts={checkedProducts}
//                   setCheckedProducts={setCheckedProducts}
//                 />
//               </Grid>
//             </Grid>
//           </Box>
//         ) : (
//           'No data found'
//         )}
//         <Box display={'flex'} justifyContent={'flex-end'}>
//           <Pagination
//             count={pagination.totalPages}
//             page={pagination.currentPage}
//             color="primary"
//             onChange={handlePageChange}
//           />
//         </Box>
//       </DashboardCard2>
//     </PageContainer>
//   );
// };

// export default AllProducts;

import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import Products from './Products';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import TextInputs from 'src/components/inputs/TextInputs';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import * as XLSX from 'xlsx';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
// import Book1Product from '../../assets/excel/Book1Product.xlsx';
import Book2Product from '../../assets/excel/Book2Product.xlsx';
import SearchImg from '../../assets/search.svg';

import { MdClear } from "react-icons/md";
import { useSelector, useDispatch } from 'react-redux';
import {
  setAllProductData,
  setSearchFilter,
  setItemsPerPage,
  setCurrentPage,
  removeProductsFromState,
  resetFilters,
} from 'src/redux/slices/productSlice';
import BulkUploadProductDialog from './components/BulkUploadProductDialog'; // adjust path to match where you saved it

const AllProducts = () => {
  const dispatch = useDispatch();

  const [checkedProducts, setCheckedProducts] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [openDialogue, setOpenDialogue] = useState(false);
  const [uploadedData, setUploadedData] = useState(null);
  const [showLoader, setShowLoader] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    filteredProducts,
    pagination,
    filters
  } = useSelector((state) => ({
    filteredProducts: state.product.filteredProducts,
    pagination: state.product.pagination,
    filters: state.product.filters
  }));
const { fetchAllProducts, activeBranchId, createManyProduct, setShowMessage, deleteManyProduct  ,
    branchData,
    OwnerVarification,
    ownerData,
    getOwnerIdByBranchId,
  } = useMain();

  const isMasked = branchData?.isMasked || false;

  /* MASK AUTH STATE */
  const [authOpen, setAuthOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isAuthorised, setIsAuthorised] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);
  const [ownerId, setOwnerId] = useState(null);
  console.log('DEBUG →', { filteredProducts, pagination, showLoader, isAuthorised, activeBranchId, isMasked });

  /* CHECK STORED ACCESS */
 /* CHECK STORED ACCESS */
/* CHECK STORED ACCESS */
useEffect(() => {
  if (!isMasked) {
    setIsAuthorised(true);
    return;
  }
  if (!branchData) return; // wait until branchData is loaded

  const ts = localStorage.getItem('reportAccessTimestamp');
  if (ts && Date.now() - ts < 10 * 60 * 1000) {
    setIsAuthorised(true);
  }
  // dialog opens only after ownerId loads — handled below
}, [isMasked, branchData]);

useEffect(() => {
  if (!isMasked || isAuthorised) return;
  if (ownerId) {
    setAuthOpen(true); // only open once ownerId is ready
  }
}, [ownerId, isMasked, isAuthorised]);
/* FETCH OWNER ID ON MOUNT/TAB OPEN */
useEffect(() => {
  const fetchOwnerIdOnLoad = async () => {
    const branchId = activeBranchId || branchData?._id || localStorage.getItem('branchId');
    if (branchId && typeof getOwnerIdByBranchId === 'function') {
      const ownerRes = await getOwnerIdByBranchId(branchId);
      const extractedId = ownerRes?.data?.ownerId || ownerRes?.ownerId || ownerRes?.data?._id;
      const finalId = (typeof extractedId === 'object' && extractedId?._id) ? extractedId._id : extractedId;
      if (typeof finalId === 'string') {
        setOwnerId(finalId);
      }
    }
  };
  fetchOwnerIdOnLoad();
}, [activeBranchId, branchData?._id, getOwnerIdByBranchId]);

  const getData = async () => {
    try {
      setShowLoader(true);
      const res = await fetchAllProducts(activeBranchId);
      if (res.statusCode === 200) {
        dispatch(setAllProductData(res?.data));
      } else {
        setShowMessage({
          message: res.message || 'Failed to fetch data',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error',
      });
    } finally {
      setShowLoader(false);
    }
  };
useEffect(() => {
  if (activeBranchId && isAuthorised) {
    getData();
    dispatch(resetFilters());
  }
}, [activeBranchId, isAuthorised]);
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
       const jsonData = XLSX.utils.sheet_to_json(sheet);

        // Map Excel columns to database keys, supporting both camelCase and Space Case headers
        const formattedData = jsonData.map((item) => ({
          vendorName: item.vendorName || item['vendorName'],
          productName: item.productName || item['productName'],
          hsnCode: item.hsnCode || item['hsnCode'],
          // mrp: item.mrp || item['mrp'],
          volume: item.volume || item['volume'],
          unit: item.unit || item['unit'],
          purchasePrice: item.purchasePrice || item['purchasePrice'],
          productCount: item.productCount || item['productCount'],
          sellPrice: item.sellPrice || item['sellPrice'],
          rewardPoints: item.rewardPoints || item['rewardPoints'],
          staffIncentive: item.staffIncentive || item['staffIncentive'],
          incentiveType: item.incentiveType || item['incentiveType'] || '%',
          barcode: item.barcode || item['barcode'],
        
          GST: item.GST || item['GST'] || 18,
          taxStatus: (item.taxStatus || item['taxStatus']) === 'Exclusive' ? 'withoutTax' : (item.taxStatus || item['taxStatus']) === 'Inclusive' ? 'withTax' : 'noGst',
        }));
        setUploadedData(formattedData);
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const downloadExcelTemplate = () => {
    //old gst code
    // const a = document.createElement('a');
    // a.href = Book2Product;
    // a.download = 'product_template.xlsx';
    // document.body.appendChild(a);
    // a.click();
    // document.body.removeChild(a);
    // closeModal();
    const headers = [
      "vendorName",
      "productName",
      "hsnCode",
      "volume",
      "unit",
      // "mrp",
      "purchasePrice",
      "sellPrice",
      "productCount",
      "barcode",
      "rewardPoints",
      "staffIncentive",
      "incentiveType",
      "GST",
      "taxStatus"
    ];


    const sampleData = [
      {
         "vendorName" : "akash",
        "productName": "Shampoo",
         "hsnCode": "33051010",
        "volume": 500,
        "unit": "ml",
        // "mrp": 500,
         "purchasePrice": 400,
        "sellPrice": 450,
        "productCount": 10,
        "volume": 500,
         "barcode": "123456789",
       "rewardPoints": 10,
        "staffIncentive": 5,
        "incentiveType": "%",
        "GST": 18,
        "taxStatus": "Inclusive",
      },
      {
        "vendorName" : "akash",
        "productName": "Shampoo two",
         "hsnCode": "33051010",
        "volume": 500,
        "unit": "ml",
        // "mrp": 500,
         "purchasePrice": 400,
        "sellPrice": 450,
        "productCount": 10,
        "volume": 500,
         "barcode": "123456789",
       "rewardPoints": 10,
        "staffIncentive": 5,
        "incentiveType": "INR",
        "GST": 12,
        "taxStatus": "Exclusive",
      },
    ];

    const ws = XLSX.utils.json_to_sheet(sampleData, { header: headers });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Products");
    XLSX.writeFile(wb, "product_template.xlsx");
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!uploadedData) {
      return setShowMessage({ message: 'Upload a valid file', messageType: 'error' });
    }

    try {
      setShowLoader(true);
      const res = await createManyProduct(activeBranchId, { bulkData: uploadedData });
      if (res?.statusCode === 200) {
        setShowMessage({ message: res.message || 'Uploaded successfully', messageType: 'success' });
        setUploadedData(null);
        getData();
      } else {
        setShowMessage({ message: res.message || 'Upload failed', messageType: 'error' });
      }
    } catch (err) {
      setShowMessage({ message: err.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setShowLoader(false);
      closeModal();
    }
  };

const handleDeleteDialogueClose = () => {
    setOpenDialogue(false);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    dispatch(setItemsPerPage(newLimit));
    // No need to manually set currentPage here - it's handled in the reducer
  };

  const handlePageChange = (e, page) => {
    dispatch(setCurrentPage(page));
  };

  // Remove only leading spaces while typing (spaces between words still work)
  const handleSearchChange = (e) => {
    dispatch(setSearchFilter(e.target.value.trimStart()));
  };

  // Trims the pasted text, then inserts it at the cursor position
  const handleSearchPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').trim();
    const { selectionStart, selectionEnd, value } = e.target;
    const next = (value.slice(0, selectionStart) + pasted + value.slice(selectionEnd)).trim();
    dispatch(setSearchFilter(next));
  };

  // Trims trailing spaces when the user leaves the box
  const handleSearchBlur = (e) => {
    const trimmed = e.target.value.trim();
    if (trimmed !== e.target.value) {
      dispatch(setSearchFilter(trimmed));
    }
  };

  const handleBulkDelete = () => {
    setOpenDialogue(true);
  };

 const handleCloseDialogue = () => {
    setAuthOpen(false);
    setPassword('');
    setShowPassword(false);
  };

  /* PASSWORD SUBMIT  */
  const handleAuthSubmit = async () => {
  if (!password) {
    setShowMessage({ message: 'Enter login password', messageType: 'error' });
    return;
  }

  if (!ownerId) {
    setShowMessage({ message: 'Owner ID not found. Please refresh and try again.', messageType: 'error' });
    return;
  }

  try {
    setAuthLoading(true);
    const res = await OwnerVarification(ownerId, { password }); // <-- changed from ownerData?._id

    if (res?.statusCode === 200) {
      localStorage.setItem('reportAccessTimestamp', Date.now());
      setIsAuthorised(true);
      setAuthOpen(false);
      setPassword('');
      setShowPassword(false);
    } else {
      setShowMessage({ message: res?.message || 'Invalid password', messageType: 'error' });
    }
  } catch (err) {
    console.error('Auth error:', err);
    setShowMessage({ message: 'Something went wrong', messageType: 'error' });
  } finally {
    setAuthLoading(false);
  }
};
  const submitBulkDelete = async () => {
    try {
      setDeleteLoading(true);
      const productIds = checkedProducts.map((item) => item?._id);
      const res = await deleteManyProduct({ ids: productIds }, activeBranchId);
      if (res.statusCode === 200) {
        setShowMessage({ message: 'Products deleted successfully', messageType: 'success' });
        setCheckedProducts([]);
        dispatch(removeProductsFromState(productIds));
      } else {
        setShowMessage({ message: res.message || 'Error deleting products', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setDeleteLoading(false);
      handleDeleteDialogueClose();
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  if (isMasked && !isAuthorised) {
    return (
      <PageContainer title="Manage Products" description="this contains all Products">
        <DashboardCard2 title="Manage Products">
          <Dialog open={authOpen} onClose={handleCloseDialogue}>
            <DialogTitle>Confirm Request</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Please enter the owner password to access this page.
              </DialogContentText>
              <Box style={{ marginTop: '10px' }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextInputs
                      title="Login Password"
                      name="password"
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      handleChange={(e) => setPassword(e.target.value)}
                      disabled={authLoading}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword((prev) => !prev)}
                              edge="end"
                              disabled={authLoading}
                            >
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialogue}>Cancel</Button>
              <Button onClick={handleAuthSubmit} disabled={authLoading}>
                {authLoading ? 'Verifying...' : 'Submit'}
              </Button>
            </DialogActions>
          </Dialog>
        </DashboardCard2>
      </PageContainer>
    );
  }
  return (
  <PageContainer title="Manage Products" description="this contains all Products">
  <DashboardCard2 title="Manage Products">
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'flex-end', 
      marginBottom: '1.7rem' 
    }}>
      {/* Left side - Show per page */}
      <div>
        <InputLabel>Show per page</InputLabel>
        <Select
          style={{
            borderRadius: '7px',
            border: '0.5px solid #6174DD',
            padding: '4px 12px',
            background: '#FFF',
            height: '40px',
            width: '100px',
          }}
          value={pagination.itemsPerPage}
          onChange={handleLimitChange}
        >
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={50}>50</MenuItem>
          <MenuItem value={100}>100</MenuItem>
          <MenuItem value={200}>200</MenuItem>
                     <MenuItem value={1000000}>All</MenuItem>

        </Select>
      </div>

      {/* Right side - Search and Upload/Delete button */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'flex-end', 
        gap: '0.5rem'
      }}>
        {/* Search */}
        <div style={{ width: '170px', flexShrink: 0 }} onClick={() => document.getElementById('search-input').focus()}>
          <InputLabel>Search</InputLabel>
          <div 
            className="search-input" 
            style={{ 
              display: 'flex', 
              alignItems: 'center',
              border: '0.5px solid #6174DD',
              borderRadius: '7px',
              padding: '4px 12px',
              background: '#FFF',
              height: '40px',
              width: '100%',
              maxWidth: 'none',
              margin: 0,
              boxSizing: 'border-box'
            }}
          >
            <img src={SearchImg} alt="" />
            <input
              id="search-input"
              type="text"
              placeholder="Search Products..."
              value={filters.search || ''}
              onChange={handleSearchChange}
              onPaste={handleSearchPaste}
              onBlur={handleSearchBlur}
              style={{ 
                marginLeft: '0.5rem', 
                border: 'none', 
                outline: 'none',
                background: 'transparent',
                flex: 1
              }}
            />
            {filters.search && (
              <IconButton
                onClick={() => dispatch(setSearchFilter(''))}
                style={{ padding: 1 }}
              >
                <MdClear style={{
                  color: '#000',
                  marginRight: '-0.2rem',
                  marginTop: '0.1rem',
                  fontSize: '1.1rem'
                }} />
              </IconButton>
            )}
          </div>
        </div>

        {/* Upload/Delete Button */}
        <div>
          {checkedProducts.length ? (
            <Button
              variant="contained"
              color="primary"
              sx={{
                background: '#ff4d4d',
                height: '40px',
                minWidth: '120px',
                '&:hover': {
                  background: '#ff6666',
                },
              }}
              onClick={handleBulkDelete}
            >
              Delete
            </Button>
          ) : (
          <BulkUploadProductDialog onUploaded={getData} />
          )}
        </div>
      </div>
    </div>

    {/* Modal Dialog */}
    <Dialog open={isModalOpen} onClose={closeModal}>
      <DialogTitle>Create Many Products</DialogTitle>
      <form onSubmit={handleFormSubmit}>
        <Box p={2}>
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileChange}
          />
        </Box>
        {showLoader && <ShowLoader value={showLoader} />}
        <Box p={2}>
          <Button type="submit" variant="contained" color="primary">
            Submit
          </Button>
          <Button
            variant="outlined"
            color="primary"
            sx={{ ml: 2 }}
            onClick={downloadExcelTemplate}
          >
            <ArrowCircleDownIcon sx={{ margin: '0px 2px 0px 0px' }} />
            Sample Download
          </Button>
        </Box>
      </form>
    </Dialog>

    {/* Delete Dialog */}
      <Dialog open={openDialogue} onClose={handleDeleteDialogueClose}>
      <DialogTitle>Delete item</DialogTitle>
      <DialogContent>
        <DialogContentText>Are you sure you want to delete this data?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDeleteDialogueClose}>Cancel</Button>
        <Button onClick={submitBulkDelete} autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>

    {showLoader ? (
      <ShowLoader />
    ) : filteredProducts.length > 0 ? (
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
          <Products
          checkedProducts={checkedProducts}
          setCheckedProducts={setCheckedProducts}
          isAuthorised={isAuthorised}
          isMasked={isMasked}
          search={(filters.search || '').trim()}
          />
          </Grid>
        </Grid>
      </Box>
    ) : (
      'No data found'
    )}
    <Box display={'flex'} justifyContent={'flex-end'}>
      <Pagination
        count={pagination.totalPages}
        page={pagination.currentPage}
        color="primary"
        onChange={handlePageChange}
      />
    </Box>
  </DashboardCard2>
</PageContainer>
  );
};

export default AllProducts;